import { Button, Flex, Heading, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/dist/client/router';
import Image from 'next/image';

const OurTeamBanner = () => {
  const { t } = useTranslation(`landing`);
  const { push } = useRouter();
  return (
    <section className="boxed-container">
      <Flex
        direction={[`column`, null, null, `row`]}
        bgColor="#74c4cb"
        borderRadius={[`3xl`, null, null, `6xl`]}
        color="white"
        pe={[9, null, 9, 10]}
        ps={[9, null, 9, 24]}
        py={[6, null, 9, 20]}
        mx={[0, null, 10, 16]}
        align="center"
        justify="center"
      >
        <Flex
          whiteSpace="pre-line"
          pe={10}
          w={[`full`, null, null, 3 / 5]}
          direction="column"
          justify="space-between"
        >
          <div>
            <Text mb={3} fontSize={[`md`, null, null, `3xl`]}>
              {t(`our_team.lead`)}
            </Text>
            <Heading fontSize={[`3xl`, `4xl`, `5xl`, `6xl`]} color="inherit">
              {t(`our_team.header`)}
            </Heading>
            <Text
              lineHeight={2}
              mt={[7, null, 8]}
              fontSize={[`sm`, null, `md`]}
            >
              {t(`our_team.description`)}
            </Text>
          </div>
          <Button
            variant="solid"
            bgColor="white"
            height={[`61px`, null, `79px`]}
            mt={16}
            py={5}
            onClick={() => push(`/about-us`)}
            pr={[4, null, 8]}
            pl={[4, null, 8]}
            borderRadius="17px"
            w="fit-content"
            transition="all 0.2s ease-in-out"
            color="brand.500"
            _hover={{ bgColor: `#ffffffb3` }}
          >
            {t(`our_team.button_action`)}
          </Button>
        </Flex>
        <Flex
          mt={[10, null, null, 0]}
          justify="center"
          align="center"
          width={[`full`, null, null, 2 / 5]}
        >
          <Image
            src="/images/landing/landing-about-us.png"
            width={483}
            height={483}
            alt={t(`our_team.header`)}
          />
        </Flex>
      </Flex>
    </section>
  );
};

export default OurTeamBanner;
